module.exports = __webpack_public_path__ + "img/product-program-phone-ykp.e1258cf7.png";